// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban,
     IconMail, IconCalendar, IconNfc, IconUserCircle ,
     IconUserScreen
    } from "@tabler/icons-react"

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| APPLICATION MENU ITEMS ||============================== //

const etudiants = {
    id: 'etudiant',
    title: ["J. ",<FormattedMessage id="etudiants" />],
    type: 'group',
    icon: <IconUserScreen />, // Use a valid icon component here
   /*  children: [
        {
            id: 'funcoes2',
            title: <FormattedMessage id="gestion_etudiants" />,
            type: 'collapse',
            icon: icons.IconUserCheck, */
            children: [
                {
                    id: 'configurationNumeroEtudiant1',
                    title: ["1. ", <FormattedMessage id="configurationNumeroEtudiant1" />],
                    type: 'item',
                    url: '/etudiants/NumeroEtudiantParFaculte'
                },

            
                {
                    id: 'nouveauEtudiant',
                    title: ["2. ",<FormattedMessage id="mouveauEtudiant" />],
                    type: 'item',
                    url: '/etudiants/NewStudents'
                },

                {
                    id: 'equivalencias_menu_text1',
                    title: ["3. ", <FormattedMessage id="equivalencias_menu_text" />],
                    type: 'item',
                    url: '/etudiants/Equivalencias'
                },

                {
                    id: 'actualizacao_dados_estudante1',
                    title: ["4. ",<FormattedMessage id="actualizacao_dados_estudante" />],
                    type: 'item',
                    url: '/etudiants/ReleveCoteImpressionActualizacaoDadosEstudante'
                },

                {
                    id: 'listeETudiant_general',
                    title: ["5. ", <FormattedMessage id="listEtudiants_general" />],
                    type: 'item',
                    url: '/etudiants/ListEtudiantsGeneral'
                },
                {
                    id: 'listeETudiant_par_promotion',
                    title: ["6. ", <FormattedMessage id="listEtudiants" />],
                    type: 'item',
                    url: '/etudiants/ListEtudiants'
                },

                {
                    id: 'type_inscription_normal_attribuer_cours_etudiant1',
                    title: ["7. ", <FormattedMessage id="type_inscription_normal_attribuer_cours_etudiant" />],
                    type: 'item',
                    url: '/etudiants/EnregistrerCoursEtudiantSpeciaux'
                },

                {
                    id: 'releveNote',
                    title: ["8. ", <FormattedMessage id="bulletin_de_points" />],
                    type: 'item',
                    url: '/etudiants/ReleveCoteImpression'
                },
                {
                    id: 'extraitEtudiant',
                    title: ["9. ", <FormattedMessage id="extrait_compite_etudia" />],
                    type: 'item',
                    url: '/etudiants/ExtraitCommpteEtudiant'
                },
                {
                    id: 'boursier',
                    title: ["10. ", <FormattedMessage id="boursiers_menu_text" />],
                    type: 'item',
                    url: '/etudiants/Bolseriros'
                },
                {
                    id: 'desistant',
                    title: ["11. ", <FormattedMessage id="desistente" />],
                    type: 'item',
                    url: '/etudiants/Desistente'
                },
                {
                    id: 'acessEtudiants',
                    title: ["12. ", <FormattedMessage id="acces_etudiants_au_logiciel" />],
                    type: 'item',
                    url: '/etudiants/LoginEtudiants'
                },

                {
                    id: 'acessEtudiantsgeneral',
                    title: ["13. ", <FormattedMessage id="acces_etudiants_au_logiciel_general" />],
                    type: 'item',
                    url: '/etudiants/LoginEtudiantsGeneral'
                },

                {
                    id: 'access_futuriss_list1',
                    title: ["14. ", <FormattedMessage id="access_futuriss_list" />],
                    type: 'item',
                    url: '/etudiants/ListEtudiantsAccessToFuturiss'
                },

                {
                    id: 'declaration_diploma_impressao`',
                    title: ["15. ", <FormattedMessage id="declaration_diploma_impressao" />],
                    type: 'item',
                    url: '/etudiants/DeclarationsEDiplomaImprression'
                },

                {
                    id: 'cartao_estudante1`',
                    title: ["16. ", <FormattedMessage id="cartao_estudante" />],
                    type: 'item',
                    url: '/etudiants/CartaoEstudante'
                },

                {
                    id: 'controle_securite1`',
                    title: ["16. ", <FormattedMessage id="controle_securite1" />],
                    type: 'item',
                    url: '/etudiants/controlAccessFuturiss'
                },

                
            ]
   //     }
   // ]
};

export default etudiants;
